'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _elementActions = require('../../../../element/elementActions');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./ShowBackgroundTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getToolActive = function getToolActive(props) {
    return props.selectedElements.first().getIn(['content', 'showBackground']);
};

var shouldShowTool = function shouldShowTool(props) {
    return props.selectedElements.reduce(function (acc, element) {
        return acc || element.getIn(['content', 'image', 'transparent']) && !element.getIn(['content', 'color']) && !element.getIn(['content', 'showCaption']);
    }, false);
};

var toolSelector = (0, _reselect.createSelector)(function (state, props) {
    return getToolActive(props);
}, function (state, props) {
    return shouldShowTool(props);
}, function (isActive, showTool) {
    return {
        isActive: isActive,
        showTool: showTool
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        handleMouseDown: function handleMouseDown(event) {
            var showBackgroundValue = getToolActive(ownProps);
            var changes = { showBackground: !showBackgroundValue };
            dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));
        }
    };
};

var ShowBackgroundTool = function ShowBackgroundTool(props) {
    if (!props.showTool) return null;

    return _react2.default.createElement(
        _Tool2.default,
        _extends({}, props, { name: props.name, isActive: !props.isActive, className: 'ShowBackgroundTool' }),
        _react2.default.createElement(_Icon2.default, { name: props.isActive ? 'toolbar-transparent' : 'toolbar-transparent-on' })
    );
};

ShowBackgroundTool.propTypes = {
    name: _propTypes2.default.string,
    isActive: _propTypes2.default.bool,
    showTool: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(toolSelector, mapDispatchToProps)(ShowBackgroundTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/showBackgroundTool/ShowBackgroundTool.js
// module id = 2250
// module chunks = 0